import type { RepairOption, ServiceOfferOption } from '../types';
import type { CatalogRow } from './progressiveRepairCatalog';

export const projectPublicRepair = (s: CatalogRow): RepairOption => ({
                                id: String(s.id),
                                name: s.service_name as string,
                                price: s.price as string,
                                pricePresentation: s.price_presentation as RepairOption['pricePresentation'],
                                duration: s.duration as string,
                                description: (s.semantic_customer_description || s.description) as string,
                                focusKeyword: (s.focus_keyword || s.seo_keywords || '') as string,
                                metaTitle: (s.meta_title || s.seo_title || '') as string,
                                metaDescription: (s.meta_description || s.seo_description || '') as string,
                                semanticArchetype: String(s.semantic_archetype || ''),
                                semanticIntent: String(s.semantic_intent || ''),
                                semanticServiceFamily: String(s.semantic_service_family || ''),
                                altText: (s.alt_text || s.altText || '') as string,
                                isActive: s.is_active !== undefined ? s.is_active === 1 || s.is_active === true : true,
                                isStartingFrom: s.is_starting_from !== undefined ? (s.is_starting_from === 1 || s.is_starting_from === true) : false,
                    originalPrice: (s.original_price as string) || '',
                    masterServiceId: String(s.master_service_stable_id || ''),
                                 masterServiceSlug: String(s.master_service_slug || ''),
                                 masterServiceName: String(s.master_service_name || ''),
                                 canonicalPath: String(s.canonical_path || ''),
                                 detailPageEligible: s.detail_page_eligible === true || s.detail_page_eligible === 1,
                                 detailCanonicalPath: typeof s.detail_canonical_path === 'string' && s.detail_canonical_path.trim()
                                     ? s.detail_canonical_path
                                     : null,
                    serviceOptions: Array.isArray(s.service_options)
                        ? (s.service_options as ServiceOfferOption[])
                        : []
                });

export async function loadSelectedModelRepairs(request: (path: string) => Promise<unknown>, modelId: string): Promise<RepairOption[]> {
  if (!modelId) return [];
    const data = await request('/api/public/repairs?modelId=' + encodeURIComponent(modelId));
    if (!Array.isArray(data) || data.some(row => !row || typeof row !== 'object' || String(row.model_id) !== modelId)) throw new Error('INVALID_MODEL_DETAIL_RESPONSE');
    return (data as CatalogRow[]).map(projectPublicRepair);
}
